<!-- To Do List -->
<mat-card
    class="daxa-card to-do-list-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">
                To Do List
            </h5>
        </mat-card-title>
        <mat-card-subtitle>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0" placeholder="Chercher une tâche..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="to-do-list-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource">

                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox
                                (change)="$event ? toggleAllRows() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                [aria-label]="checkboxLabel()"
                            >
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox
                                (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)"
                                [aria-label]="checkboxLabel(row)"
                            >
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Task Name Column -->
                    <ng-container matColumnDef="taskName">
                        <th mat-header-cell *matHeaderCellDef>
                            Task Name
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.taskName}}
                        </td>
                    </ng-container>

                    <!-- Due Date Column -->
                    <ng-container matColumnDef="dueDate">
                        <th mat-header-cell *matHeaderCellDef>
                            Due Date
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.dueDate}}
                        </td>
                    </ng-container>

                    <!-- Priority Column -->
                    <ng-container matColumnDef="priority">
                        <th mat-header-cell *matHeaderCellDef>
                            Priority
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.priority}}
                        </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="daxa-badge in-progress d-inline-block" *ngIf="element.status.inProgress">
                                {{element.status.inProgress}}
                            </span>
                            <span class="daxa-badge pending d-inline-block" *ngIf="element.status.pending">
                                {{element.status.pending}}
                            </span>
                            <span class="daxa-badge completed d-inline-block" *ngIf="element.status.completed">
                                {{element.status.completed}}
                            </span>
                            <span class="daxa-badge not-started d-inline-block" *ngIf="element.status.notStarted">
                                {{element.status.notStarted}}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                            Action
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info">
                                <button type="button" mat-button matTooltip="View" matTooltipPosition="above">
                                    <i class="material-symbols-outlined">
                                        {{element.action.view}}
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above" (click)="openEditMode(element)">
                                    <i class="material-symbols-outlined">
                                        {{element.action.edit}}
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above" (click)="deleteTask(element)">
                                    <i class="material-symbols-outlined">
                                        {{element.action.delete}}
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    
                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="7">Aucun résultat trouvé pour "{{input.value}}"</td>
                    </tr>

                </table>
            </div>
        </div>
        <div class="add-new-task-btn text-right">
            <button
                mat-button
                (click)="toggleClass()"
            >
                + Add New Task
            </button>
        </div>
    </mat-card-content>
</mat-card>

<!-- Popup -->
<div
    class="add-new-task-popup"
    [class.active]="classApplied"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="popup-dialog">
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-header>
                <mat-card-title>
                    <h5 class="mt-0 mb-0">
                        {{ isEditMode ? 'Modifier la tâche' : 'Add New Task' }}
                    </h5>
                </mat-card-title>
                <mat-card-subtitle>
                    <button
                        mat-button
                        (click)="toggleClass()"
                    >
                        <i class="ri-close-fill"></i>
                    </button>
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <form [formGroup]="taskForm" (ngSubmit)="onSubmit()">
                    <div class="row">
                        <div class="col-md-12">
                            <label class="main-label d-block lh-1 text-black">
                                Task Name
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    Task name
                                </mat-label>
                                <input matInput placeholder="E.g. Analyse de sol" formControlName="taskName">
                            </mat-form-field>
                        </div>
                        <div class="col-md-12">
                            <label class="main-label d-block lh-1 text-black">
                                Due Date
                            </label>
                            <mat-form-field class="date">
                                <mat-label>
                                    Choose a date
                                </mat-label>
                                <input matInput [matDatepicker]="dueDate" formControlName="dueDate">
                                <mat-datepicker-toggle matIconSuffix [for]="dueDate"></mat-datepicker-toggle>
                                <mat-datepicker #dueDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <label class="main-label d-block lh-1 text-black">
                                Priority
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    Select
                                </mat-label>
                                <mat-select formControlName="priority">
                                    <mat-option *ngFor="let priority of priorities" [value]="priority">
                                        {{ priority }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <label class="main-label d-block lh-1 text-black">
                                Status
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    Select
                                </mat-label>
                                <mat-select formControlName="status">
                                    <mat-option *ngFor="let status of statuses" [value]="status">
                                        {{ status }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="btn-box">
                        <button
                            type="button"
                            mat-button
                            (click)="toggleClass()"
                        >
                            Cancel
                        </button>
                        <button type="submit" mat-button [disabled]="taskForm.invalid">
                            {{ isEditMode ? 'Mettre à jour' : 'Create' }}
                        </button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>